/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenGenericIcon64Regular = forwardRef('TechScreenGenericIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 9C10.701 9 6 13.701 6 19.5v21C6 46.299 10.701 51 16.5 51h31C53.299 51 58 46.299 58 40.5v-21C58 13.701 53.299 9 47.5 9h-31ZM9 19.5a7.5 7.5 0 0 1 7.5-7.5h31a7.5 7.5 0 0 1 7.5 7.5v21a7.5 7.5 0 0 1-7.5 7.5h-31A7.5 7.5 0 0 1 9 40.5v-21Z" }),
        React.createElement("path", { d: "M16 54a1.5 1.5 0 0 0 0 3h32a1.5 1.5 0 0 0 0-3H16Z" })));
});
